import React from "react";
import { formatCompact } from "../../utils/formatCompact";
import {
  transactionLedgerSubline,
  transactionStatusMeta,
  transactionTypeLabel,
} from "../../users/userTransactionHelpers";

function txHeat(tx, maxAmount) {
  if (tx.status === "Pending" || tx.status === "Hold") return 100;
  const amount = Math.abs(Number(tx.amount) || 0);
  if (!maxAmount) return 12;
  return Math.max(8, Math.round((amount / maxAmount) * 100));
}

export default function TransactionFloorRow({ tx, rank, selected, onSelect, heatPct }) {
  const status = transactionStatusMeta(tx.status);
  const typeLabel = transactionTypeLabel(tx.transactionType);
  const needsAction = tx.status === "Pending" || tx.status === "Hold";
  const statusTone =
    status.tone === "live" ? "live" : status.tone === "warn" ? "warn" : "muted";

  return (
    <button
      type="button"
      className={`amf-row atx-row ${selected ? "amf-row-selected" : ""} ${needsAction ? "amf-row-action" : ""}`}
      aria-pressed={selected}
      onClick={onSelect}
    >
      <span
        className="amf-row-heat"
        style={{ "--heat": `${heatPct}%` }}
        title={needsAction ? "Needs action" : "Amount size"}
        aria-hidden
      />
      <span className="amf-row-rank">{String(rank).padStart(2, "0")}</span>
      <span className="amf-row-body atx-row-body">
        <span className="amf-row-top atx-row-top">
          <span className="amf-row-name" title={typeLabel}>
            {typeLabel}
          </span>
          <span className={`amf-row-tag amf-row-tag-${statusTone}`}>{status.label}</span>
          {tx.isDisputed ? <span className="amf-row-tag amf-row-tag-warn">Disputed</span> : null}
        </span>
        <span className="amf-row-sub atx-row-sub">
          {transactionLedgerSubline(tx, formatCompact)}
        </span>
      </span>
    </button>
  );
}

export { txHeat };
